import { handleResponse, handleError, headerset } from "../apiUtils";

// ============================================
// BASE URL
// ============================================

const baseUrl = () => {
    return process.env.API_URL + "/api/schedulazione/reparti/";
};

// ============================================
// API FUNCTIONS
// ============================================

/**
 * Fetch lista completa reparti (anagrafica, no paginazione)
 */
export function fetchReparti() {
    const url = baseUrl() + "?numero_record=1000";

    return fetch(url, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: headerset().Authorization,
        },
    })
        .then(handleResponse)
        .catch(handleError);
}